export enum DutyCancellationReason {
  NoDriverAvailable = 'noDriverAvailable',
  NoVehicleAvailable = 'noVehicleAvailable',
  VehicleBreakdown = 'vehicleBreakdown',
  VehicleIncident = 'vehicleIncident',
  DeviceIssue = 'deviceIssue',
  RiderBiohazard = 'riderBiohazard',
  DriverMedical = 'driverMedical',
  DriverCallout = 'driverCallout',
  DriverPersonalEmergency = 'driverPersonalEmergency',
  Other = 'other',
}

export interface IDutyCancellationPostBody {
  cancelledBy: DutyCancelledBy
  reason: DutyCancellationReason
  notes: string | null
}

export interface IDutyCancellationResponse {
  id: string
  createdAt: number
  updatedAt: number
  dutyId: string
  cancelledBy: DutyCancelledBy
  reason: DutyCancellationReason
  notes: string | null
}

export enum DutyCancelledBy {
  Admin = 'admin',
  Engine = 'engine',
}
